import { gql } from "@apollo/client";

export const VALIDATE_RI = gql`
    mutation ValidateRI(
        $input: ValidateRIInput!)
    {
        validateRI(
            input: $input
        ){
            idControlRI
            idEvaluacion
            tipoNotificacion
            idEstadoValidacion
            fechaValidacion
            idUsuarioValidador
            idProfesionalAsignado
            requiereOtroProfesional
            idMotivoRechazo
        }
    }
`;